export default "__VITE_ASSET__db3bc323__"